import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import { RouterProps, withRouter } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as audioVideoHistoryActions from '../../../actions/audio-video-history';
import * as checkoutActions from '../../../actions/checkout';
import * as checkoutAudioVideoActions from '../../../actions/checkout/audio-video';
import { IFacility } from '../../../models/Facility';
import { InmateAccountPayment } from '../../../models/InmateAccountPayment';
import { IAppState } from '../../../reducers';
import { IAudioVideoPaymentHistoryState } from '../../../reducers/audioVideoPaymentHistory';
import { Service, Service as ServiceType } from '../../../reducers/checkout';
import { IPaginatedResponse } from '../../../services/api';
import PageTitle from '../../PageTitle';
import Navigation from '../Navigation';
import HistoryRow from './HistoryRow';
import LoadingRow from './LoadingRow';

interface IHistoryProps extends RouterProps {
  facilities: IFacility[]
  paymentHistory: IAudioVideoPaymentHistoryState
  load(): Promise<IPaginatedResponse<InmateAccountPayment>>
  buyAgain: (payment: InmateAccountPayment) => void
}

const History: React.FC<IHistoryProps> = props => {
  useEffect(() => {
    props.load();
  }, []);

  const dispatch = useDispatch();

  return (
    <>
      <PageTitle title="Inmate Wallet - Voice & Video Calls Only Transaction History" />
      <Navigation title="Inmate Wallet - Voice & Video Calls Only Transaction History" />

      <main className="container pt-3">
        <section className="row">
          <div className="col mb-3">
            <div className="border border-dark rounded h-100 pb-4">
              <h5 className="bg-dark text-light px-5 py-3"><span></span>Inmate Wallet - Voice & Video Calls Only Purchase History</h5>
              <div className="px-lg-5 p-4">
                <button className="btn btn-info btn-block" onClick={() =>{
                  dispatch(checkoutActions.selectService(ServiceType.AudioVideo));
                  props.history.push('/checkout/audio-video');
                  return false;
                }}>Make new Inmate Wallet - Voice & Video Calls Only call payment</button>
              </div>

              {props.paymentHistory.loading && <LoadingRow />}

              {props.paymentHistory && props.paymentHistory.history && props.paymentHistory.history.data && props.paymentHistory.history.data.map(h => {
                const facility = (props.facilities || []).filter(f => f.id == h.inmate.facility?.id).pop();
                return (
                  <HistoryRow
                    facility={facility}
                    payment={h}
                    onBuyAgain={() => {
                      props.buyAgain(h);
                      props.history.push('/checkout/audio-video');
                    }}
                    key={h.id} />
                );
              })}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default withRouter(connect(
  (state: IAppState) => ({
    paymentHistory: state.audioVideoPaymentHistory,
    facilities: state.common.facilities
  }),
  ((dispatch: ThunkDispatch<IAppState, undefined, Action>) => ({
    load: () => dispatch(audioVideoHistoryActions.load()),
    buyAgain: (payment: InmateAccountPayment) => {
      dispatch(checkoutAudioVideoActions.reset());
      dispatch(checkoutActions.selectService(Service.AudioVideo));
      dispatch(checkoutActions.selectFacilityById(payment.inmate.facility.id));
      dispatch(checkoutAudioVideoActions.setDetails(payment.inmate, payment.amount));
    }
  }))
)(History));
